import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MessageService} from 'primeng/api';
import {FormControl, FormGroup} from '@angular/forms';
import {BookingService} from '../../@shared/new-services/booking.service';
import {CacheService} from '../../@shared/services/cache.service';
import {environment} from '../../../environments/environment';
import {UserMgmtService} from '../../@shared/new-services/user-mgmt.service';

@Component({
    selector: 'bookings-filter',
    templateUrl: './bookings-filter.component.html',
    styleUrls: ['./bookings-filter.component.scss']
})
export class BookingsFilterComponent implements OnInit {

    @Input() resetBookingForm = false;
    @Output() emitFilterValue: EventEmitter<any> = new EventEmitter<any>();

    activeOptions: any = [
        {optionName: 'Active', optionValue: true},
        {optionName: 'Delivered', optionValue: false}
    ];
    orderTypes: any;
    isLoading = false;
    loggedInUser = this.cacheService.retrieveParsedResponse('detailedLoggedInUser');
    ports: any;
    displayDetailedFilter = false;
    bookingFilterForm: FormGroup;
    siCounts: any;
    isAdmin = false;
    customers: any[] = [];

    constructor(private bookingService: BookingService, private messageService: MessageService,
                private cacheService: CacheService,
                private userMgmtService: UserMgmtService) {
    }

    ngOnInit(): void {
        this.createBookingFilterForm();
        this.getBookingOrderTypes();
        this.getPorts();
        this.userMgmtService.getCurrentUser()
            .subscribe((x) => {
                console.log(x);
                x.roles?.map((role) => {
                    if (role?.roleId === environment.portalAdminRoleId || role?.roleId === environment.ffAdminRoleId) {
                        this.isAdmin = true;
                    }
                });
            });
        // this.loggedInUser?.roles?.map((role) => {
        //     if (role?.roleId === environment.portalAdminRoleId || role?.roleId === environment.ffAdminRoleId) {
        //         this.isAdmin = true;
        //     }
        // });
        this.getEntitiesByUser();
    }

    ngOnChanges() {
        if (this.resetBookingForm) {
            this.createBookingFilterForm();
        }
    }


    getBookingOrderTypes() {
        this.isLoading = true;
        this.bookingService
            .getBookingOrderTypes()
            .subscribe(
                (x) => {
                    this.isLoading = false;
                    this.orderTypes = x;
                }, error => {
                    this.isLoading = false;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'OrderTypes Error !',
                        detail: error?.message ? error?.message : error,
                        key: 'error-messages-toast'
                    });
                }
            );

    }

    getPorts() {
        this.isLoading = true;
        this.bookingService
            .getAllPorts()
            .subscribe(
                (x) => {
                    this.isLoading = false;
                    this.ports = x;
                }, error => {
                    this.isLoading = false;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Ports Error !',
                        detail: error?.message ? error?.message : error,
                        key: 'error-messages-toast'
                    });
                }
            );
    }

    onSubmitBookingFilterForm(from?: any) {
        // Validations for Custom Functionality
        this.bookingFilterForm.controls.filterByIdentifier.setValue(null);
        const bookingFilterValue = this.bookingFilterForm.value;
        if (from === 'shipmentType' && bookingFilterValue?.orderTypes?.length === 0) {
            return;
        }
        this.emitFilterValue.emit({
            bookingFilterValue
        });
        this.displayDetailedFilter = false;
    }

    onSearchOfBookingOrBLNumber() {
        this.bookingFilterForm.patchValue({
            orderTypes: null,
            activeOnly: null,
            customerReferenceNumber: null,
            fromDate: null,
            toDate: null,
            loadPort: null,
            dischargePort: null,
            submittedSI: false,
            draftSI: false
        });
        const bookingFilterValue = this.bookingFilterForm.value;
        if (bookingFilterValue.filterByIdentifier === '') {
            this.bookingFilterForm.patchValue({
                activeOnly: true
            });
        }
        this.emitFilterValue.emit({
            bookingFilterValue
        });
    }

    createBookingFilterForm() {
        this.bookingFilterForm = new FormGroup({
            filterByIdentifier: new FormControl(),
            orderTypes: new FormControl([]),
            activeOnly: new FormControl(true),
            customerReferenceNumber: new FormControl(),
            fromDate: new FormControl(),
            toDate: new FormControl(),
            loadPort: new FormControl(),
            dischargePort: new FormControl(),
            submittedSI: new FormControl(false),
            draftSI: new FormControl(false),
            businessEntityId: new FormControl(),
        });
    }

    resetBookingFilterForm() {
        this.createBookingFilterForm();
        this.emitFilterValue.emit({
            action: 'reset'
        });
        this.displayDetailedFilter = false;
    }

    getSIBookingsCounts(businessEntityId: any) {
        this.bookingService.getBookingsSiCount(businessEntityId)
            .subscribe(
                (x) => {
                    this.siCounts = x;
                }
            );
    }

    getEntitiesByUser() {
        this.userMgmtService
            .getEntitiesByUser()
            .subscribe((entities: any) => {
                this.customers = entities;
            });
    }

    applyCustomerFilter() {
        const bookingFilterValue = this.bookingFilterForm.value;
        console.log(bookingFilterValue);
        this.getSIBookingsCounts(bookingFilterValue.businessEntityId);
        if (bookingFilterValue?.businessEntityId === null) {
            bookingFilterValue.businessEntityId = '';
        }
        this.emitFilterValue.emit({
            bookingFilterValue
        });
    }

}
